import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { Avatar } from "primevue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UAvatar',
    props: {
        label: {
            type: String,
            default: ""
        }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Avatar), {
                label: __props.label,
                size: "xlarge",
                shape: "circle",
                class: "u-avatar"
            }, null, 8, ["label"]));
        };
    }
});
